export class LeaderboardConstants {
}
LeaderboardConstants.globalLeaderboardUrl = '';
LeaderboardConstants.maximumLeaderboardAPIRankingRangeLimit = 100;
LeaderboardConstants.emptyUsernameSearch = '';
LeaderboardConstants.emptyRank = '-';
